/**
 * A failed direct-to-storage PUT, in words a clinic can act on.
 *
 * The status code used to be printed raw — «(کد 403)», Latin digits inside a
 * Persian sentence, and a number that means nothing at a reception desk. A
 * 403 from a presigned URL is almost always the signature expiring; 413 is
 * size; anything else is the connection.
 */
export function uploadFailureFa(fileName: string, status: number): string {
  const cause =
    status === 403
      ? 'مهلت بارگذاری تمام شد؛ دوباره تلاش کنید'
      : status === 413
        ? 'حجم فایل بیش از حد مجاز است'
        : 'ارتباط برای بارگذاری فایل برقرار نشد؛ دوباره امتحان کنید';
  return `بارگذاری «${fileName}» انجام نشد: ${cause}.`;
}
